// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2_58X","requiredAsterisk":"Info_requiredAsterisk__2BLap"};